import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/contact';
import Container from '../../containers/app';
import Root from '../../components/root';

export default function PageContact() {
  return (
    <Root title={PAGE_TITLE.CONTACT}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
